import { Component, Input, OnInit } from '@angular/core'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'alarm-app-install-modal',
  templateUrl: './alarm-app-install-modal.component.html',
  styleUrls: ['./alarm-app-install-modal.component.scss'],
})
export class AlarmAppInstallModalComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private logService: LogService,
    private localeService: LocaleService
  ) {}

  @Input() title: string = '이 기능은 앱에서만 쓸 수 있어요'
  @Input() description: string = '타입스 앱에서 모든 소셜 플레이를 즐겨보세요'
  @Input() buttonText: string = '타입스 앱 열기'
  @Input() appLink: string | undefined
  @Input() logOnClickInstall: (() => void) | undefined
  isKo = this.localeService.isKo

  ngOnInit(): void {}

  async onClickInstallApp(): Promise<void> {
    this.logOnClickInstall?.()
    switch (this.appLink) {
      case 'cabinet':
        this.logService.cabinet.logCabinetHistoryInstallAppClicked()
      default:
        break
    }
  }

  onClickClose(): void {
    this.modalService.dismiss()
  }

  onOpenAppSucceed(): void {
    this.modalService.dismiss()
  }
}
